import * as React from 'react';
import { Body1 } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface IMobileGalleryFooterProps {
  title?: string;
  call?: React.ReactNode;
  chat?: React.ReactNode;
}

export function MobileGalleryFooter({ title, call, chat }: IMobileGalleryFooterProps): React.JSX.Element {
  return (
    <div className={styles['footer-content']}>
      <div className={styles['container']} data-testid="MobileHeader">
        <Body1 color="text-inverted-default">{title}</Body1>
        <div className={styles['actions']}>
          <div className={styles['call-button']}>{call}</div>
          {chat}
        </div>
      </div>
    </div>
  );
}
